// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ari-user\r\n{\r\n    text-align: center;\r\n}\r\n", "",{"version":3,"sources":["webpack://./screens/App/screens/ARIUser/containers/ARIUser.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;AACtB","sourcesContent":[".ari-user\r\n{\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
